import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { HYDRATE } from 'next-redux-wrapper';
import { IShmPage, TypeInitData } from '@models/ShmPage';
import { RootState } from '@redux/store';
import { TypePromiseTooltips } from '@services/ServiceUtils/TypePromise';

const initialState: IShmPage = {
  data: {
    questions: [],
    shops: [],
    filterShops: [],
    activeShop: null,
    tabShop: 0,
    filter: [],
    commets: [],
    calc: {
      AUTOCLASS: [],
      DIAM: [],
      autoClass: '',
      diam: '',
      activeShop: '',
      discount: 0,
      activeAutoClass: '',
    },
    resultCalc: null,
    resultR: null,
    resultAutoClass: null,
    tooltips: [],
    isLoadedInitData: false,
  },
};

export const shmSlice = createSlice({
  name: 'shm',
  initialState,
  reducers: {
    initData: (state, action: PayloadAction<TypeInitData>) => {
      const { questions, commets, calc, tooltips } = action.payload;
      state.data.questions = questions;
      state.data.commets = commets.comentsList;
      state.data.calc.DIAM = calc?.DIAM || [];
      state.data.calc.AUTOCLASS = calc?.AUTOCLASS || [];
      state.data.tooltips = tooltips;
      state.data.isLoadedInitData = true;
    },
    setShops: (state, action: PayloadAction<any>) => {
      state.data.shops = action.payload;
      state.data.filterShops = action.payload;
    },
    setQueshions: (state, action: PayloadAction<any>) => {
      state.data.questions = action.payload;
    },
    setDataCalc: (state, action: PayloadAction<any>) => {
      state.data.calc = action.payload;
    },
    setResultCalc: (state, action: PayloadAction<any>) => {
      state.data.resultCalc = action.payload;
      state.data.resultAutoClass = state.data.calc.autoClass;
      state.data.resultR = state.data.calc.diam;
    },
    setComment: (state, action: PayloadAction<any>) => {
      state.data.commets = action.payload;
    },
    setAutoClass: (state, action: PayloadAction<any>) => {
      state.data.calc.autoClass = action.payload;
    },
    setDiam: (state, action: PayloadAction<any>) => {
      state.data.calc.diam = action.payload;
    },
    setShop: (state, action: PayloadAction<any>) => {
      state.data.calc.activeShop = action.payload;
    },
    setDiscount: (state, action: PayloadAction<any>) => {
      state.data.calc.discount = action.payload;
    },
    setActiveShop: (state, action: PayloadAction<any>) => {
      state.data.activeShop = action.payload;
    },
    setTabShop: (state, action: PayloadAction<any>) => {
      state.data.tabShop = action.payload;
    },
    setFilterShop: (state, action: PayloadAction<any>) => {
      state.data.filter = action.payload;
    },
    setTooltips: (state, action: PayloadAction<TypePromiseTooltips[]>) => {
      state.data.tooltips = action.payload;
    },
  },
  extraReducers: {
    [HYDRATE]: (state, action) => {
      return {
        ...state,
        ...action.payload.shm,
      };
    },
  },
});

export const {
  setShops,
  setQueshions,
  setDataCalc,
  setResultCalc,
  setComment,
  setAutoClass,
  setDiam,
  setActiveShop,
  setShop,
  setDiscount,
  setTabShop,
  setFilterShop,
  setTooltips,
  initData,
} = shmSlice.actions;

export const selectShmData = (state: RootState) => state.shm.data;

export const shmReducer = shmSlice.reducer;
